import React from 'react'

const Heading = ({titel}) => {
  return (
    <h2 className=' font-dm font-bold text-lg md:text-[39px] mb-6 lg:mb-12'>{titel}</h2>
  )
}

export default Heading